import React, { useState } from 'react'
import Logo1688 from '../../../assets/img/platform/1688.png'
// import LogoChinabuybuy from '../../../assets/img/platform/chinabuybuy.png'
// import LogoShopee from '../../../assets/img/platform/shopee.svg'
import LogoTaobao from '../../../assets/img/platform/taobao.png'
import LogoTmall from '../../../assets/img/platform/tmall.png'
import LogoTiktok from '../../../assets/img/platform/tiktok.svg'
// import LogoAmazon from '../../../assets/img/platform/amazon.png'

import { Box, Button, Flex, Group, Image, NumberInput, Switch, Tabs, Text, TextInput, } from '@mantine/core'

import { notificationError, notificationSuccess } from '../../ui/Notifications'
import { addProductUrl, addProductUrlAmazon, addProductUrlChinabuybuy, addProductUrlShopee, addProductUrlTiktok } from '../../../services/products'


const FormAddProductUrl = ({ onCloseModal, reloadList }) => {
  const [activeTab, setActiveTab] = useState('1688')

  const [url, setUrl] = useState('')
  const [markupPrice, setMarkupPrice] = useState(0)
  const [isTranslate, setIsTranslate] = useState(false)

  const [loadingForm, setLoadingForm] = useState(false)

  const validateInput = () => {
    let isValid = (activeTab || activeTab !== '') && (url || url !== '')
    if (activeTab === 'chinabuybuy' && url.toLowerCase().startsWith('https://chinabuybuy.com/')) {
      isValid = true
    } else if (activeTab === 'shopee' && url.toLowerCase().startsWith('https://shopee')) {
      isValid = true
    } else if (activeTab === '1688' && url.toLowerCase().startsWith('https://detail.1688.com/')) {
      isValid = true
    } else if (activeTab === 'taobao' && url.toLowerCase().startsWith('https://item.taobao.com/')) {
      isValid = true
    } else if (activeTab === 'amazon' && url.toLowerCase().startsWith('https://www.amazon.')) {
      isValid = true
    } else if (activeTab === 'tmall' && url.toLowerCase().startsWith('https://detail.tmall.com/')) {
      isValid = true
    } else if (activeTab === 'tiktok' && (url.toLowerCase().startsWith('https://shop-id.tokopedia.com/') || url.toLowerCase().startsWith('https://vt.tokopedia.com/') || url.toLowerCase().startsWith('https://www.tokopedia.com/') || url.toLowerCase().startsWith('https://vt.tokopedia.com/'))) {
      isValid = true
    } else {
      isValid = false
    }
    return isValid
  }

  const generatePayload = () => {
    if (activeTab === '1688' || activeTab === 'taobao' || activeTab === 'tmall' || activeTab === 'tiktok') {
      return {
        url,
        markup_price: markupPrice || 0,
        is_translated_images: isTranslate || false,
      }
    }
    return {
      url,
    }
  }

  // submit data
  const submitProductUrl = async () => {
    setLoadingForm(true)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = 'Something Went Wrong At Syncing Product'

    const isError = !validateInput()

    if (isError) {
      setLoadingForm(false)
      return
    }

    // generate payload
    const payload = generatePayload()

    if (activeTab === '1688' || activeTab === 'tmall' || activeTab === 'taobao' || activeTab === 'tiktok') {
      // methodFunction = addProductUrl(payload) // need to call manual in bellow
      titleMessageSuccess = `Successfully Sync Product From ${activeTab}`
      captionMessageSuccess = `You have been imported new Product from ${activeTab}`
    } else if (activeTab === 'shopee') {
      methodFunction = addProductUrlShopee(url, payload)
      titleMessageSuccess = 'Successfully Sync Product From Shopee'
      captionMessageSuccess = 'You have been imported new Product from Shopee'
    } else if (activeTab === 'amazon') {
      methodFunction = addProductUrlAmazon(payload)
      titleMessageSuccess = 'Successfully Sync Product From Amazon'
      captionMessageSuccess = 'You have been imported new Product from Amazon'
    } else if (activeTab === 'chinabuybuy') {
      methodFunction = addProductUrlChinabuybuy(url, payload)
      titleMessageSuccess = 'Successfully Sync Product From Chinabuybuy'
      captionMessageSuccess = 'You have been imported new Product from Chinabuybuy'
    }

    // helper
    const _onSuccess = () => {
      onCloseModal()
      reloadList()
      notificationSuccess(titleMessageSuccess, captionMessageSuccess)
    }

    // hit API
    if (activeTab === '1688' || activeTab === 'tmall' || activeTab === 'taobao' || activeTab === 'tiktok') {
      let attempt = 0;
      let success = false;

      do {
        try {
          const response = await addProductUrl(payload) // call manuall for this loop

          if (response.success) {
            _onSuccess();
            success = true;
          } else {
            throw new Error("Response not successful");
          }
        } catch (error) {
          attempt++;
          if (attempt >= 3) {
            notificationError(titleMessageError, error.message || "Unknown error");
          } else {
            console.warn(`Retrying... (${attempt}/${3})`);
          }
        } finally {
          if (attempt >= 3 || success) {
            setLoadingForm(false);
          }
        }
      } while (!success && attempt < 3);
    }
    else {
      try {
        const response = await methodFunction
        if (response.success) {
          _onSuccess()
        }
      } catch (error) {
        notificationError(titleMessageError, error.message)
      } finally {
        setLoadingForm(false)
      }
    }
  }

  const renderTabs = () => {
    return (
      <Tabs value={activeTab} onChange={setActiveTab}>
        <Tabs.List>
          <Tabs.Tab value="1688" >
            <Image h={50} w={70} fit="contain" radius="md" src={Logo1688} />
          </Tabs.Tab>
          <Tabs.Tab value="taobao">
            <Image h={50} w={70} fit="contain" radius="md" src={LogoTaobao} />
          </Tabs.Tab>
          <Tabs.Tab value="tmall">
            <Image h={50} w={70} fit="contain" radius="md" src={LogoTmall} />
          </Tabs.Tab>
          <Tabs.Tab value="tiktok">
            <Image h={50} w={70} fit="contain" radius="md" src={LogoTiktok} />
          </Tabs.Tab>
          {/* <Tabs.Tab value="amazon">
            <Image h={50} w={70} fit="contain" radius="md" src={LogoAmazon} />
          </Tabs.Tab>
          <Tabs.Tab value="chinabuybuy">
            <Image h={50} w={70} fit="contain" radius="md" src={LogoChinabuybuy} />
          </Tabs.Tab>
          <Tabs.Tab value="shopee">
            <Image h={50} w={70} fit="contain" radius="md" src={LogoShopee} />
          </Tabs.Tab> */}
        </Tabs.List>
      </Tabs>
    )
  }

  const renderMarkupInput = () => {
    if (activeTab === '1688' || activeTab === 'taobao' || activeTab === 'tmall' || activeTab === 'tiktok') {
      return (
        <Box mt='lg' w={'50%'}>
          <NumberInput
            label="Markup Price (optional)"
            size='xs'
            suffix="%"
            clampBehavior="strict"
            min={0}
            max={100}
            value={markupPrice}
            onChange={setMarkupPrice}
          />
          <Switch
            mt='lg'
            size='xs'
            label="Translate text from product images to English"
            description="This options will make slower progress"
            checked={isTranslate}
            onChange={(event) => setIsTranslate(event.currentTarget.checked)}
          />
        </Box>
      )
    }
  }

  const mappingFormAddProductUrl = () => {
    return (
      <Box>
        {renderTabs()}

        <Box my="md">
          <Flex align="flex-end" gap="sm">
            <Box style={{ flexGrow: 1 }}>
              <TextInput
                name='url'
                value={url}
                label='URL'
                onChange={(val) => setUrl(val.target.value)}
                withAsterisk
                size='xs'
              />
            </Box>
          </Flex>

          <Text size="xs" mt={4}>
            Only Accept URL Format that include <span style={{ color: 'blue', fontWeight: 'bold' }}>
              {activeTab === '1688' ? 'https://detail.1688.com/****'
                : activeTab === 'taobao' ? 'https://item.taobao.com/****'
                  : activeTab === 'tmall' ? 'https://detail.tmall.com/item.htm?****'
                    : activeTab === 'amazon' ? 'https://www.amazon.**/****'
                      : activeTab === 'chinabuybuy' ? 'https://chinabuybuy.com/****'
                        : activeTab === 'tiktok' ? 'https://shop-id.tokopedia.com/****'
                          : 'https://shopee.co.id/****'
              }
            </span>
          </Text>
        </Box>
        {renderMarkupInput()}
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
              <Button disabled={!validateInput()} size='xs' loading={loadingForm} variant="filled" onClick={() => submitProductUrl()}>Sync Now</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {mappingFormAddProductUrl()}
    </Box>
  )
}

export default FormAddProductUrl